import { DocketItem } from '@oolio-group/domain';

export const formatComboSuffix = (parentComboName?: string): string => {
  const trimmed = parentComboName?.trim();
  if (!trimmed) return '';
  return ` (${trimmed})`;
};

export const getDocketItemDisplayName = (item: DocketItem): string =>
  `${item.product?.name ?? ''}${formatComboSuffix(item.parentCombo?.name)}`;
